import { useModalMeta } from "@/shared/atoms/useModal";
import { lazy, useRef, Suspense, useState } from "react";
import { Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import "react-quill/dist/quill.snow.css";
import {Col} from "react-grid-system";
import Button from "../Button/Button";
import Textfield from "../Input/Textfield";
import Modal, { ModalProps } from "../Modal/Modal";
import Spinner from "../Spinner/Spinner";
const ReactQuill = lazy(() => import("react-quill"));

const QrPrintModal = ({ onExit, ...props }: ModalProps) => {
  const [value, setValue] = useState(
    "<p>Scan de QR-code om je bestelling te plaatsen!</p>",
  );
  const pdfRef = useRef(); // Ref voor de container
  const [meta] = useModalMeta();
  const [width, setWidth] = useState(160);
  const url = meta?.url ?? "";
  const { t } = useTranslation("");

  const generatePDF = async () => {
    const input = pdfRef.current;
    const { default: html2canvas } = await import("html2canvas");

    html2canvas(input, { scale: 2 }).then(async (canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const { default: jsPDF } = await import("jspdf");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210; // A4 breedte in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Behoud aspect ratio

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("download.pdf");
    });
  };

  return (
    <Modal width={"80rem"} onExit={onExit} {...props}>
      <Row>
        <Col xs={12} md={6}>
          <div className="m-auto">
            <h1>{t("downloadQrCode")}</h1>
            <div ref={pdfRef} style={{ color: "black", padding: "20px", background: "#fff" }}>
              <div style={{ width: `${width}px` }}>
                <QRCode
                  style={{ height: "auto", maxWidth: "33rem", width: "100%" }}
                  value={url}
                  viewBox={`0 0 256 256`}
                />
              </div>
              <div dangerouslySetInnerHTML={{ __html: value }} />
            </div>
          </div>
        </Col>
        <Col xs={12} md={6}>
          <Textfield
            label={t("sizeQrInPixels")}
            type="number"
            min={50}
            onChange={(e) => setWidth(parseInt(e.target.value))}
            value={width}
          />
          <div className="mt-[2rem]">
            <Suspense fallback={<Spinner size="0.25rem" />}>
              <ReactQuill theme="snow" value={value} onChange={setValue} />
            </Suspense>
          </div>
        </Col>
      </Row>

      <div className="my-8 flex gap-4">
        <Button onClick={generatePDF}>{t("download")}</Button>
        <Button onClick={() => onExit()}>{t("close")}</Button>
      </div>
    </Modal>
  );
};

export default QrPrintModal;
